module.exports = __webpack_public_path__ + "static/media/carta_48.f31b39c2.jpg";